export async function saveNewCost(d) {
  try {
    const response = await fetch("https://hs2api.razamit.pl/saveNewFv", {
      method: "POST",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(d),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia użytkownika:", err);
    throw err;
  }
}
export async function AddAditionalVFEdit(row) {
  try {
    const response = await fetch("https://hs2api.razamit.pl/saveAditionalFV", {
      method: "POST",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(row),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia użytkownika:", err);
    throw err;
  }
}

export async function changestatus(row, status) {
  try {
    const response = await fetch(`https://hs2api.razamit.pl/changestatus/${row.id}/${status}`, {
      method: "PUT",
      credentials: 'include',
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd usuwania kosztu:", err);
    throw err;
  }
}


export async function deleteCost(row) {
  try {
    const response = await fetch(`https://hs2api.razamit.pl/deleteCost/${row.id}`, {
      method: "DELETE",
      credentials: 'include',
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd usuwania kosztu:", err);
    throw err;
  }
}

export async function GetCostDetails(id) {
  try {
    const response = await fetch(`https://hs2api.razamit.pl/getAditionalCostDetails/${id}`, {
      method: "GET",
      credentials: 'include',
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd pobierania szczegółów kosztu:", err);
    throw err;
  }
}
